import Text from '../../../../shared/Text'
import { FormattedMessage } from 'react-intl'
import ExternalLinkButton from '../../../../shared/ExternalLinkButton'
import Svg from '../../../../shared/Svg'
import classNames from 'classnames'
import styles from './MobileChromeExtensionPromptCard.module.scss'

interface MobileChromeExtensionPromptCardProps {
  className: string
}

export const MobileChromeExtensionPromptCard = ({
  className,
}: MobileChromeExtensionPromptCardProps) => (
  <div className={classNames(styles.container, className)}>
    <div className={styles.imageBackground} />
    <div className={styles.contents}>
      <Text className={styles.header} element='h1' weight='bold' size='l'>
        <FormattedMessage
          id='HomeSearch.listingDetails.getChromeExtensionCardHeader'
          defaultMessage='Do you use Google Chrome'
        />
      </Text>

      <Text className={styles.description} element='p' size='s' variant='white'>
        <FormattedMessage
          id='HomeSearch.listingDetails.getChromeExtensionCardDetails'
          defaultMessage='You can now get these same insights into affordability on other listing sites across the web — for free.'
        />
      </Text>

      <ExternalLinkButton
        secondary
        fullWidth
        href='https://chrome.google.com/webstore/detail/homebot-for-chrome/oigjeliojmhdahlmjhackoknjmohedfi'
      >
        <Text className={styles.buttonLinkText}>
          <FormattedMessage
            id='HomeSearch.listingDetails.getChromeExtensionCardButtonText'
            defaultMessage='Get the Extension'
          />
        </Text>
        <Svg width='16' height='16' viewBox='0 0 16 16' fill='none'>
          <path
            xmlns='http://www.w3.org/2000/svg'
            d='M8 0C12.4127 0 16 3.5873 16 8C16 12.4127 12.4127 16 8 16C3.5873 16 0 12.4127 0 8C0 3.5873 3.5873 0 8 0ZM7.95238 13.6667L13.619 8L7.95238 2.33333L6.33333 3.95238L9.2381 6.85714H2.28571V9.14286H9.2381L6.33333 12.0476L7.95238 13.6667Z'
            fill='white'
          />
        </Svg>
      </ExternalLinkButton>
    </div>
  </div>
)
